import { render, staticRenderFns } from "./IfpsmLogin.vue?vue&type=template&id=cf39227a"
import script from "./IfpsmLogin.vue?vue&type=script&lang=js"
export * from "./IfpsmLogin.vue?vue&type=script&lang=js"
import style0 from "./IfpsmLogin.vue?vue&type=style&index=0&id=cf39227a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports